import type {ReactNode} from "react";
import {OtsTooltip} from "./OtsTooltip";

export type OtsTruncatedTextProps = {
  children: ReactNode;
  /** Full rich content when the visible line is a compact summary. Defaults to the visible content. */
  tooltip?: ReactNode;
  className?: string;
};

/** A single ellipsized line whose full value remains available to pointer and keyboard users. */
export function OtsTruncatedText({children, tooltip, className}: OtsTruncatedTextProps) {
  return (
    <OtsTooltip
      content={tooltip ?? children}
      density="compact"
      className="!flex w-full min-w-0 max-w-full"
      panelClassName="whitespace-normal break-words"
    >
      <span tabIndex={0} className={["block min-w-0 max-w-full truncate", className].filter(Boolean).join(" ")}>
        {children}
      </span>
    </OtsTooltip>
  );
}
